import { useNumberMask } from "datepicker";
import React, { useRef, useState } from "react";
import { LoadingButton } from "./components/SavingButton";
import { Bot, pairingCode } from "./bot-loaders";

function SpanArray({code}:{code:string[]}){
    return <div className="code-part d-flex">
        {code.map(a => <span>{a}</span>)}
    </div>
}

function PairCode({code}:{code:string}){
    const code1 = code.substring(0,4).match(/./g)
    const code2 = code.substring(4).match(/./g)
    return <div className="pairing-code d-flex">
        <SpanArray code={code1} />
        <div className="code-separator">-</div>
        <SpanArray code={code2} />
    </div>
}


export function PairingCode({bot}:{bot:Bot}){
    const [state, setState] = useState<"begin" | "input">("begin");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState<string>(null)
    const [code, setCode] = useState<string>(null);
    const ref = useRef<HTMLInputElement>();
    const [loading, setLoading] = useState(false);
    useNumberMask({mask:"phone", ref})

    async function getCode(){
        if(!phone.match(/\(\d{2}\) \d{4,5}-\d{4}/)){
            return setError("Informe o telefone.");
        }
        setLoading(true);
        try{
            setCode(await pairingCode(bot, '55' + phone.replace(/[^\d]/g, '')));
        }catch(e){
            setError(typeof e == 'string' ? e : e.message || "Erro ao requisitar código")
        }
        setLoading(false);
    }

    if(code != null){
        return <div className="mt-3">
            <p>Logar com número de telefone:</p>
            <div>
                <div className="mb-2 text-center text-muted">Digite este código em seu aparelho:</div>
                <PairCode code={code} />
            </div>
        </div>
    }

    if(state == 'input'){
        return <div className="mt-3">
            <p>Logar com número de telefone:</p>
            <div className="d-flex">
                <input ref={ref} className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} />
                <LoadingButton saving={loading} icon="fa fa-arrow-right" className="ms-2 btn btn-primary text-nowrap" onClick={getCode}>Enviar</LoadingButton>
            </div>
            {error != null && <div className="mt-2"><b>Erro: </b> {error}</div>}
        </div>
    }

    return <div className="mt-3">
        <p>Logar com número de telefone: <button className="ms-2 btn btn-primary" onClick={()=>setState("input")}><i className="fa fa-arrow-right"></i></button></p>
    </div>
    
}